import React, { useEffect, useState, ReactElement } from "react";
import {
  Dialog,
  DialogActions,
  DialogBody,
  DialogTitle,
} from "../design/dialog";
import { Button } from "../design/button";
import { Input } from "../design/input";
import { Field, Label } from "../design/fieldset";
import { ClockIcon } from "@heroicons/react/20/solid";

interface TimeButtonProps {
  value?: string;
  onChange: (newValue: string | undefined) => void;
  trigger?: (props: { onClick: () => void }) => ReactElement;
}

const TimeButton: React.FC<TimeButtonProps> = ({
  value,
  onChange,
  trigger,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [time, setTime] = useState<string | undefined>(
    value ?? localStorage.getItem("time") ?? undefined,
  );

  useEffect(() => {
    if (time !== undefined) {
      localStorage.setItem("time", time);
    }
  }, [time]);

  const openDialog = () => setIsOpen(true);
  const closeDialog = () => setIsOpen(false);

  return (
    <>
      {trigger ? (
        trigger({ onClick: openDialog })
      ) : (
        <Button onClick={openDialog}>
          <ClockIcon className="w-5 h-5 mr-1" />
          {value ? value : "Set Transition Time"}
        </Button>
      )}

      <Dialog open={isOpen} onClose={closeDialog}>
        <DialogTitle>Select a Time</DialogTitle>
        <DialogBody>
          <Field>
            <Label>Time</Label>
            <Input
              type="time"
              value={time || ""}
              onChange={(e) => {
                setTime(e.target.value);
                localStorage.setItem("time", e.target.value);
              }}
            />
          </Field>
        </DialogBody>
        <DialogActions>
          <Button plain onClick={closeDialog}>
            Cancel
          </Button>
          <Button
            onClick={() => {
              setTime(undefined);
              onChange(undefined);
              closeDialog();
            }}
          >
            Clear
          </Button>
          <Button
            onClick={() => {
              onChange(time);
              closeDialog();
            }}
            disabled={!time}
          >
            Save
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default TimeButton;
